"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceProvider = void 0;
class ServiceProvider {
    constructor() {
        this._values = new Map();
    }
    transient(id, value) {
        this._values.set(id, {
            type: ResolveType.Transient,
            value: value,
        });
    }
    singleton(id, value) {
        const instance = value instanceof Function ? value() : value;
        this._values.set(id, {
            type: ResolveType.Singleton,
            value: instance,
        });
    }
    resolve(id) {
        const value = this._values.get(id);
        if (value === undefined) {
            throw `Service with id ${id} not registered`;
        }
        else {
            if (value.type === ResolveType.Singleton) {
                return value.value;
            }
            else {
                const func = value.value;
                const instance = func();
                return instance;
            }
        }
    }
}
exports.ServiceProvider = ServiceProvider;
var ResolveType;
(function (ResolveType) {
    ResolveType[ResolveType["Singleton"] = 0] = "Singleton";
    ResolveType[ResolveType["Transient"] = 1] = "Transient";
})(ResolveType || (ResolveType = {}));
//# sourceMappingURL=ServiceProvider.js.map